<div class="rs-container">
  <!-- Header row: kind eyebrow + meta + refresh icon -->
  <div class="rs-head">
    <div class="rs-eyebrow">
      <ion-icon [name]="kindIcon" aria-hidden="true"></ion-icon>
      <span>{{ kindEyebrowKey | translate }}</span>
      <span class="rs-eyebrow__sep" *ngIf="lastAnalyzedAt" aria-hidden="true">·</span>
      <span class="rs-eyebrow__meta" *ngIf="lastAnalyzedAt">{{ 'NOVA_UPDATED_AT' | translate: { time: (lastAnalyzedAt | date:'shortTime') } }}</span>
    </div>
    <button
      *ngIf="hasSummary()"
      type="button"
      class="rs-refresh"
      [attr.aria-label]="'NOVA_REGENERATE_INSIGHTS' | translate"
      [title]="'NOVA_REGENERATE_INSIGHTS' | translate"
      (click)="analyze.emit()"
      [disabled]="isProcessing">
      <ion-icon [class.rs-refresh__spin]="isProcessing" name="refresh-outline" aria-hidden="true"></ion-icon>
    </button>
  </div>

  <h2 class="rs-label" *ngIf="label">{{ label }}</h2>

  <!-- Processing skeleton -->
  <div class="rs-stream" *ngIf="isProcessing && !hasSummary()" aria-busy="true" [attr.aria-label]="'NOVA_LOADING_RECORD_SUMMARY' | translate">
    <div class="rs-skeleton-card" *ngFor="let _ of [1,2]">
      <ion-skeleton-text [animated]="true" class="skeleton-pill"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="skeleton-line w-70"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="skeleton-line"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="skeleton-line w-80"></ion-skeleton-text>
    </div>
  </div>

  <!-- Unified card: insight sections + charts/metrics in agent order -->
  <div class="rs-stream" *ngIf="hasSummary()">
    <nova-card
      [card]="summaryValue"
      [responseId]="responseId"
      [usage]="usage"
      (openEntity)="openEntity.emit($event)"
      (action)="action.emit($event)"
      (feedback)="feedback.emit($event)">
    </nova-card>
  </div>

  <!-- Empty state -->
  <div class="rs-empty" *ngIf="!hasSummary() && !isProcessing" role="status">
    <span class="rs-empty__halo" aria-hidden="true">
      <ion-icon name="sparkles-outline" class="rs-empty__icon"></ion-icon>
    </span>
    <p class="rs-empty__title">{{ 'NOVA_NO_INSIGHTS_YET' | translate }}</p>
    <p class="rs-empty__sub">{{ kindDescriptionKey | translate }}</p>
    <button type="button" class="rs-cta" (click)="analyze.emit()" [attr.aria-label]="'NOVA_GENERATE_INSIGHTS_LABEL' | translate">
      <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
      {{ 'NOVA_GENERATE_INSIGHTS' | translate }}
    </button>
  </div>

  <p class="rs-privacy" *ngIf="hasSummary()">
    <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
    {{ 'NOVA_PROCESSED_SECURELY_CONTEXT_NOT_STORED' | translate }}
  </p>
</div>
